import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
  image?: string;
  type?: 'website' | 'article';
}

export default function SEO({
  title,
  description,
  keywords,
  canonicalPath = '/',
  image,
  type = 'website',
}: SEOProps) {
  const location = useLocation();

  const pageTitle = title ? `${title} - ${siteInfo.name}` : `${siteInfo.name} - ${siteInfo.tagline}`;
  const pageDescription = description || siteInfo.description;
  const pageKeywords = keywords || siteInfo.keywords;
  const canonicalUrl = `${siteInfo.url}${canonicalPath}`;
  const ogImage = image || 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20banner%2C%20colorful%20comic%20book%20covers%20collage%2C%20warm%20vibrant%20colors%2C%20reading%20and%20entertainment%20vibe%2C%20clean%20modern%20design%2C%20flat%20illustration%20style%2C%20simple%20background&width=1200&height=630&seq=og-default&orientation=landscape';

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDescription);
    setMeta('keywords', pageKeywords);

    setMeta('og:title', pageTitle, true);
    setMeta('og:description', pageDescription, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:type', type, true);
    setMeta('og:image', ogImage, true);
    setMeta('og:site_name', siteInfo.name, true);
    setMeta('og:locale', 'zh_CN', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', pageTitle);
    setMeta('twitter:description', pageDescription);
    setMeta('twitter:image', ogImage);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
  }, [pageTitle, pageDescription, pageKeywords, canonicalUrl, ogImage, type]);

  return null;
}